import { isEqual, min } from 'date-fns';
import { getNextShowtimeForJourney, getSortedJourneyOrderShowtimes } from '../../journey/utils/journey-utils';
import { getOrderRelatedShowtimeById } from '../../order/selectors/showtimes/get-order-related-showtime-by-id';
import { JourneyGroupType } from '../types/journey-group';
import { groupJourneysByMonthAndYear } from './group-journeys-by-month-and-year';
import { compareCurrentJourneyGroups } from './sort-journey-groups';
import { sortJourneyIdsByShowtimeStartTime } from './sort-journey-ids-by-showtime-start-time';
export const groupCurrentJourneys = (journeys) => {
    let upNextJourneyId;
    const foodAndDrinkJourneyIds = [];
    const monthlyJourneys = [];
    const groups = [];
    const startDates = journeys.reduce((acc, journey) => {
        const showtime = getNextShowtimeForJourney(journey);
        if (showtime)
            acc.push(new Date(showtime.schedule.startsAt));
        return acc;
    }, []);
    const upNextDate = startDates.length ? min(startDates) : undefined;
    journeys.forEach((journey) => {
        const showtimes = getSortedJourneyOrderShowtimes(journey);
        if (!showtimes.length) {
            foodAndDrinkJourneyIds.push(journey.id);
        }
        else {
            const showtime = getOrderRelatedShowtimeById(showtimes[0].showtimeId);
            if (!showtime)
                return;
            if (upNextDate && isEqual(new Date(showtime.schedule.startsAt), upNextDate)) {
                upNextJourneyId = journey.id;
            }
            else {
                monthlyJourneys.push(journey);
            }
        }
    });
    if (upNextJourneyId) {
        groups.push({
            id: 'UpNext',
            type: JourneyGroupType.UpNext,
            journeyIds: [upNextJourneyId]
        });
    }
    if (foodAndDrinkJourneyIds.length) {
        groups.push({
            id: 'FoodAndDrink',
            type: JourneyGroupType.FoodAndDrink,
            journeyIds: foodAndDrinkJourneyIds
        });
    }
    groups.push(...groupJourneysByMonthAndYear(monthlyJourneys, sortJourneyIdsByShowtimeStartTime));
    return groups.sort(compareCurrentJourneyGroups);
};
